import _ from 'underscore';
import { useMemo, useContext } from 'react';

import { ServerContext } from '@bingads-webui-campaign-react/mca-server-context';
import { MaxCampaigns } from '@bingads-webui-campaign-react/mca-core';

const DEFAULT_OPTIONS = {};

export const DEFAULT_CAMPAIGN_OPTIONS = { select: ['SocialProfiles'] };

export const ALL_CAMPAIGN_OPTIONS = { select: ['Ads', 'Targets', 'Keywords', 'SocialProfiles'] };

export const useCampaignVariables = (campaignId, options = DEFAULT_OPTIONS) => {
  const [serverContext] = useContext(ServerContext);
  const { CurrentAccount, CurrentCustomer } = serverContext || {};
  const { Id: accountId } = CurrentAccount || {};
  const { Id: customerId } = CurrentCustomer || {};

  return useMemo(() => _.extend({}, options, {
    locator: {
      descriptor: {
        // TODO: remove cid/aid/cpid when overreact-multi-channel is removed.
        cid: customerId,
        aid: accountId,
        cpid: campaignId,
        customer_id: customerId,
        account_id: accountId,
        campaign_id: campaignId,
      },
    },
  }), [accountId, campaignId, customerId, options]);
};

export const useCampaignsVariablesWithSocial = (options = DEFAULT_CAMPAIGN_OPTIONS) => {
  const [serverContext] = useContext(ServerContext);
  const { CurrentUser, CurrentAccount, CurrentCustomer } = serverContext || {};
  const { Id: accountId } = CurrentAccount || {};
  const { Id: customerId } = CurrentCustomer || {};
  const { Id: userId } = CurrentUser || {};
  const optionsWithTop = useMemo(() => ({
    ...options,
    top: MaxCampaigns,
  }), [options]);

  return useMemo(() => ({
    ...optionsWithTop,
    locator: {
      descriptor: {
        uid: userId,
        cid: customerId,
        aid: accountId,
        customer_id: customerId,
        account_id: accountId,
      },
    },
  }), [accountId, customerId, optionsWithTop, userId]);
};

export const useCustomerLevelVariables = () => {
  const [serverContext] = useContext(ServerContext);
  const { CurrentUser, CurrentCustomer } = serverContext || {};
  const { Id: customerId } = CurrentCustomer || {};
  const { Id: userId } = CurrentUser || {};

  return useMemo(() => ({
    locator: {
      descriptor: {
        uid: userId,
        cid: customerId,
        customer_id: customerId,
      },
    },
  }), [userId, customerId]);
};

export const useAccountLevelVariables = () => {
  const [serverContext] = useContext(ServerContext);
  const { CurrentUser, CurrentAccount, CurrentCustomer } = serverContext || {};
  const { Id: customerId } = CurrentCustomer || {};
  const { Id: accountId } = CurrentAccount || {};
  const { Id: userId } = CurrentUser || {};

  return useMemo(() => ({
    locator: {
      descriptor: {
        uid: userId,
        cid: customerId,
        aid: accountId,
        customer_id: customerId,
        account_id: accountId,
      },
    },
  }), [userId, customerId, accountId]);
};

export const useValidateUrlVariables = () => useMemo(() => ({
  locator: {
    descriptor: {
      cid: '0',
      aid: '0',
    },
  },
}), []);

export const usePostponeReadVariables = lookupCacheByVariables => useMemo(
  () => (
    lookupCacheByVariables ?
      {
        fetch: {
          postponeRead: true,
          lookupCacheByVariables,
        },
        refetch: {
          lookupCacheByVariables,
        },
        mutation: {
          lookupCacheByVariables,
        },
      } :
      {
        fetch: {
          postponeRead: true,
        },
      }),
  [lookupCacheByVariables]
);

export const useAdsVariablesOptions = () => useMemo(() => ({
  top: 50,
  pageSize: 50,
}), []);
